import React, { FC } from 'react'
import s from './QuickSearchOutput.module.sass'
import { QuickSearchPlaceItemSkeleton } from '@features/QuickSearch/ui/QuickSearchPlaceItem'

const Skeleton: FC = () => {
  return (
    <div className={s.list}>
      {Array.from({ length: 24 }).map((_, idx) => (
        <QuickSearchPlaceItemSkeleton key={idx} />
      ))}
    </div>
  )
}

export default Skeleton
